/**************************** PROXY REQUESTS *************************/

import appFetch from "./fetch";
import { ApiResponse } from "./types";

export const FETCH_PIN_URI = "/api/anobis/pinned_metric";
export const SEARCH_URI = "/api/anobis/pinned_metric";
export const FETCH_TAKE_NOTES = "/api/anobis/pinned_metric";
export const UPDATE_TAKE_NOTES = "/api/anobis/pinned_metric";
export const ADD_PIN = "/api/anobis/pinned_metric";
export const FETCH_MANAGE_METRICS = "/api/anobis/pinned_metric";

export const ADD_TAKE_NOTES = "/api/anobis/pinnedMetrics";

export const CATEGORY_URI = "/api/anobis/metrics";
export const FETCH_ALL_ORG_URI = "/api/anobis/metrics";
export const FETCH_DETAILS = "/api/anobis/metrics";

export const SEARCH_URI_ALLORGMETRICS = "/api/anobis/metrics/search";

export const FILTERS_CONFIG = "/api/anobis/filterConfig";
export const APP_CONFIG = "/api/anobis/adhocFilters";
export const APP_NOTIFICATION = "/api/anobis/banner/1";

export const ANOBIS_MINIMAL_MODE = "/api/anobis/banner/2";

export const GET_CHARTS = `/api/superset/render_filter_slices`;
export const SUPERSET_EXPLORE_JSON = `/api/superset/explore_json`;
export const LOGIN_URL = `/api/anobis/login`;
export const LOGOUT_URI = `/api/anobis/logout`;
export const USER_ROLES = `/api/anobis/userRoles`;

/**************************** PROXY REQUESTS *************************/

/**************************** HTTP ERRORS *************************/

const REQUEST_TIMED_OUT = "Request timed out, please try again later";
const GENERIC_ERROR = "Something went wrong, please try again later";
const REQUEST_TIMED_OUT_504 = "Request timed out, please try again later.";

export const HTTP_MESSAGES = {
  401: "Authorization Failed",
  404: "The requested data was not found",
  400: "Invalid request — please check your input",
  408: REQUEST_TIMED_OUT,
  504: REQUEST_TIMED_OUT_504,
  500: "Server Error, please try again later",
  503: "Server Unavailable, please try again later",
  5: GENERIC_ERROR,
  4: GENERIC_ERROR,
};
/**************************** HTTP ERRORS *************************/

/**************************** L1b SUBTEXT *************************/

export const subtext = {
  Today: "* compared to same day last week",
  Yesterday: "* compared to same day last week",
  "Last 7 days": "* compared to last 7 days",
  "Last 4 weeks": "* compared to 4 weeks ago",
};

/**************************** L1b SUBTEXT *************************/

export const OAuthConfig = {
  CLIENT_ID: "e1948bdc-f08b-4f4b-978e-1a9332bb5396",
  OAUTH_LOGIN_ENPOINT: "https://login.microsoftonline.com/830534c3-5672-4618-bd49-82e8af727e64/oauth2/v2.0",
  OAUTH_REDIRECT_URI: `/oauth_callback`,
};

export const RunningAnobisMode = Object.freeze({
  SHOW_ALL_TABS: ["Today", "Yesterday", "Last 7 days", "Last 4 weeks"],
  SHOW_ONLY_THIS_WEEK_TABS: ["Today", "Yesterday"],
  DISABLE_TABS_OTHER_THAN_TODAY: ["Today"],
  DISABLE_UI_ON_PHONE: false,
  SHOW_IM_COM_TIME_TAB: ["CurrHr_imcom", "LastHr_imcom", "Today_imcom", "Yesterday_imcom"],
  BROKEN_PODS_VISIBLE_TIME_TAB: ["CurrHr_imcom", "LastHr_imcom", "Today_imcom", "Yesterday_imcom"],
  INDIA_2_MIS_TIME_TAB: ["Today_india_2", "Yesterday_india_2", "Last 7 days_india_2", "Last 4 Weeks_india_2"], // change tab names here for india 2
  BROKEN_RESTAURANTS_VISIBLE_TIME_TAB: ["Today_india_2", "Yesterday_india_2"],
});

export const IM_COM_TABS = {
  dayGranularityTabsArray: ["Today_imcom", "Yesterday_imcom"],
};

export const TabNames = RunningAnobisMode.SHOW_ALL_TABS;

export const ThisWeekTabNames = ["Today", "Yesterday"];

/**************************** API SERVICE *************************/
export const BASE_URL = "";
export const REQUEST_TIMEOUT = 60000 + 5000; // +5000 cuz proxies front of nginx;

/**************************** LOCALSTORAGE KEYS *************************/
export const LOCALSTORAGE_TOKEN_KEY = "token";
export const LOCALSTORAGE_USER_META = "meta";

/************************** Animations ************************/
export const REFRESH_ICON_ANIMATION = {
  loop: true,
  from: { rotateZ: 0 },
  to: { rotateZ: 360 },
  config: { duration: 600 },
  delay: 200,
};

export const GRANULARITY_MAPPING = {
  Today: "1 hour",
  Yesterday: "1 hour",
  "Last 7 days": "1 day",
  "Last 4 weeks": "1 days",
};

export const FEATURE_FLAG = {
  LINE_CHART_FOR_CATEGORY_PAGE: false,
};

export const BANNER_API_REFRESH_INTERVAL = 60;
